module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAUAQMAAACDPk5SAAAAAXNSR0IArs4c6QAAAAZQTFRFAAAAl5eXDVANgAAAAAF0Uk5TAEDm2GYAAAARSURBVAjXY/jwgQGOkAER4gCjWhaBC4nJcgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/assets/images/drop-icon.png
// module id = WAaC
// module chunks = 241